import { GateNotIcon } from './GateNotIcon';

/**
 * author: Nick
 * id 3A4475B4-3774-4A2A-B672-59DAF8AE3398
 * name gate-not
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gate-not.svg
 * tags
 */
export const LogicGateNotIcon = GateNotIcon;
export default LogicGateNotIcon